import {
  EnumTableConfig,
  EnumValueConfig,
} from '@/components/table/_fieldDefinitions/enum/EnumTableConfig.ts';
import {
  messageChannelTableConfig,
  messageTypeTableConfig,
  messageTriggerTypeTableConfig,
  messageStatusTableConfig,
  recipientTypeTableConfig,
  messageTemplateTypeTableConfig,
} from '@/features/dashboard/messages/types/MessageEnums.utils.ts';
import {
  rawTransactionStatusTableConfig,
  rawTransactionDirectionTableConfig,
} from '@/features/dashboard/rawBankTransactions/types/RawTransactionEnums.utils.ts';
import {
  invitationStatusTableConfig,
  roleTableConfig,
} from '@/features/dashboard/invitations/types/InvitationEnums.utils.ts';
import { plannedTransactionPaymentStatusTableConfig } from '@/features/dashboard/plannedTransactions/types/PlannedTransactionPaymentStatusEnums.utils.ts';
import { aggregatedPaymentStatusTableConfig } from '@/features/dashboard/financialTransactions/types/AggregatedPaymentStatusEnums.utils.ts';
import { consentTypeTableConfig } from '@/features/dashboard/consentTemplates/types/ConsentTemplateType.utils.ts';
import { consentStatusTableConfig } from '@/features/dashboard/consentTemplates/types/ConsentStatus.utils.ts';
import { deliveryStatusForUserTableConfig } from '@/features/dashboard/messages/types/DeliveryStatusForUser.utils.ts';
import { discountTypeTableConfig } from '@/features/dashboard/discounts/types/DiscountType.utils.ts';
import { paymentMethodTableConfig } from '@/features/dashboard/tourConfig/types/PaymentMethod.utils.ts';
import { bookingStatusTableConfig } from '@/features/dashboard/bookings/types/BookingStatusEnums.utils.ts';
import { participantStatusTableConfig } from '@/features/dashboard/participants/types/ParticipantStatus.utils.ts';

const enumRegistry: Record<string, EnumTableConfig> = {
  MessageChannel: messageChannelTableConfig,
  MessageType: messageTypeTableConfig,
  MessageTriggerType: messageTriggerTypeTableConfig,
  MessageStatus: messageStatusTableConfig,
  RecipientType: recipientTypeTableConfig,
  RawTransactionStatus: rawTransactionStatusTableConfig,
  TransactionDirection: rawTransactionDirectionTableConfig,
  PlannedTransactionPaymentStatus: plannedTransactionPaymentStatusTableConfig,
  BookingStatus: bookingStatusTableConfig,
  ParticipantStatus: participantStatusTableConfig,
  InvitationStatus: invitationStatusTableConfig,
  Role: roleTableConfig,
  PaymentStatus: aggregatedPaymentStatusTableConfig,
  ConsentType: consentTypeTableConfig,
  ConsentStatus: consentStatusTableConfig,
  DeliveryStatusForUser: deliveryStatusForUserTableConfig,
  DiscountType: discountTypeTableConfig,
  MessageTemplateType: messageTemplateTypeTableConfig,
  // Backend nazywa ten enum `SupportedPaymentMethod`, front — `PaymentMethod`.
  SupportedPaymentMethod: paymentMethodTableConfig,
};

export const getEnumConfig = (name: string): EnumTableConfig | undefined => {
  return enumRegistry[name];
};

export const getEnumValueConfig = (
  enumName: string,
  enumKey: string,
): EnumValueConfig | undefined => {
  return enumRegistry[enumName]?.[enumKey];
};
